module.exports = __webpack_public_path__ + "static/media/credit-card.72dd5b3e.svg";